import { render, staticRenderFns } from "./PatientAppointmentTable.vue?vue&type=template&id=54426196&"
import script from "./PatientAppointmentTable.vue?vue&type=script&lang=js&"
export * from "./PatientAppointmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports